const crops = {
    crops: {
        "1": "Wassermelone",
        "2": "Kürbis: Sommerkürbis",
        "3": "Zucchini",
        "4": "Zuckerrohr",
        "5": "Einlegegurken",
        "6": "Äpfel",
        "7": "Sellerie",
        "8": "Aprikosen",
        "9": "Sellerie: grüner Herbst",
        "10": "Schnittlauch - 1. Jahr",
        "11": "Schnittlauch - 2. Jahr",
        "12": "Karotten gewaschen",
        "13": "Süßkartoffeln",
        "14": "Mais (Silage 67% Wasser)",
        "15": "Pfirsiche",
        "16": "Kartoffeln",
        "17": "Frühlingszwiebel",
        "18": "Knoblauch",
        "19": "Grünkohl",
        "20": "Erdbeeren",
        "21": "Rote Beete",
        "22": "Brokkoli",
        "23": "Rosenkohl",
        "24": "Sellerie - blanchierter Herbst",
        "25": "Zuckerrüben",
        "26": "Karotte: Winter",
        "27": "Tomaten",
        "28": "Zwiebel: Winter",
        "29": "Trauben (Tafeltrauben)",
        "30": "Salat - geleitet Sommer",
        "31": "Petersilie",
        "32": "Salat - Eichenblatt Sommer",
        "33": "Salat: Eichenblatt",
        "34": "Topinambur",
        "35": "Pflaumen",
        "36": "Cantaloup-Melone",
        "37": "Öl: Palme",
        "38": "Grüner Salat",
        "39": "Kiwi",
        "40": "Kohl: rot",
        "41": "Birnen",
        "42": "Banane",
        "43": "Endivie Eskariol - Sommer",
        "44": "Endivie Eskariol - Baby",
        "45": "Endivie: krausblättrig",
        "46": "Kohl - gemeinsame Lagerung",
        "47": "Lauch: Sommer",
        "48": "Lauch: Herbst Winter",
        "49": "Erdbeere: ewige Frucht",
        "50": "Papaya",
        "51": "Spinat",
        "52": "Tomatenverarbeitung",
        "53": "Quetschen",
        "54": "Chicoree",
        "55": "Kohl",
        "56": "Aubergine",
        "57": "Kohl: Frühling",
        "58": "Kohl: Wirsing",
        "59": "Kohl: grüner Wirsingkohl",
        "60": "Gemeine Bohne",
        "61": "Orangen",
        "62": "Schalotte: rot",
        "63": "Melone",
        "64": "Tabak (Rauch)",
        "65": "Tabak (geernteten)",
        "66": "Kaffee",
        "67": "Gerste (Frühling)",
        "68": "Weizen 10% Protein",
        "69": "Weizen 12% Protein",
        "70": "Weizen 14% Protein",
        "71": "Mais (Getreide)",
        "72": "Sonnenblume",
        "73": "Reis",
        "74": "Sorghum (Getreide)",
    },
};
export default crops;
